import React from 'react';

export const HighspotHelp = () => {
    return (
        <div>
            <p>
                Pleae note that some key pairs generated on older Mac versions may result in an OPENSSH style key being
                generated. For this to work with Highspot, you will need to transform it to an RSA key.
            </p>
            <p>This can be done using the following command:</p>
            <p>
                <code>ssh-keygen -p -P &quot;&quot; -N &quot;&quot; -m pem -f \path\to\key\file</code>
            </p>
            <p>Further details can be found at</p>
            <p>
                <a href="https://github.com/sshnet/SSH.NET/issues/485" target="_blank" rel="noopener noreferrer">
                    https://github.com/sshnet/SSH.NET/issues/485
                </a>
            </p>
        </div>
    );
};

export default HighspotHelp;
